var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileBgSection5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 346,
    viewBox: "0 0 360 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 346,
    fill: "#EE7F25"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_513_8946)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136 346L336 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.332 346L349.332 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.668 346L362.668 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 346L376 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.332 346L389.332 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.668 346L402.668 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 346L416 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.332 346L429.332 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.668 346L442.668 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 346L456 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.332 346L469.332 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.668 346L482.668 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 346L496 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.332 346L509.332 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.668 346L522.668 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 346L536 0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.332 346L549.332 0",
    stroke: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_513_8946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 346,
    fill: "white",
    transform: "translate(136)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBgSection5);
export default __webpack_public_path__ + "static/media/mobileBgSection5.37baa7f7eaa74ceac864589095fb7d15.svg";
export { ForwardRef as ReactComponent };